import { useUiStore, type ToastVariant } from "@/stores/uiStore";

const VARIANT_STYLES: Record<ToastVariant, string> = {
  info: "bg-sumi text-white",
  success: "bg-bamboo text-white",
  error: "bg-alert text-white",
};

export function ToastViewport() {
  const toasts = useUiStore((s) => s.toasts);
  if (toasts.length === 0) return null;
  return (
    <div
      className="fixed inset-x-0 top-4 z-50 flex flex-col items-center gap-2 px-4 pointer-events-none"
      role="status"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`max-w-sm rounded-card px-4 py-3 shadow-card text-sm font-bold pointer-events-auto ${VARIANT_STYLES[t.variant]}`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
